import { render, staticRenderFns } from "./theme-category.vue?vue&type=template&id=280d4fc0&scoped=true&"
import script from "./theme-category.vue?vue&type=script&lang=js&"
export * from "./theme-category.vue?vue&type=script&lang=js&"
import style0 from "./theme-category.vue?vue&type=style&index=0&id=280d4fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d4fc0",
  null
  
)

export default component.exports